import { render, staticRenderFns } from "./sportDetail.vue?vue&type=template&id=1b964425&"
import script from "./sportDetail.vue?vue&type=script&lang=js&"
export * from "./sportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports